<template>
  <div class id="Details">
    <!-- <mt-header fixed title="">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
      <mt-button slot="right">
          <img src="static/image/share@2x.png" alt="">
          <span>分享</span>
      </mt-button>
    </mt-header>-->
    <div class="header">
      <mt-swipe :autoplay="3000">
        <mt-swipe-item v-for="(item,key) in resData.imageList" v-bind:key="key">
          <img v-lazy="item" />
        </mt-swipe-item>
      </mt-swipe>
      <!-- <report-list></report-list> -->
    </div>
    <div class="title">
      <h1>{{resData.carModelName}}</h1>
      <span>
        {{resData.price}}<em>万</em>
      </span>
      <span class="new">&nbsp;新车指导价{{resData.newCarPrice}}万</span>
      <div class="programme">
        <div class="box" @click="linkStages(resData)">
          <div><span>分期购</span> 首付低至{{(resData.price*0.1).toFixed(2)}}万 月供{{parseInt(resData.price*0.9*10000/36 + resData.price*0.9*10000*0.0059)}}元</div>
          <img src="/static/image/next.png" alt />
        </div>
    </div>
      <div>{{resData.putwayTime?resData.putwayTime.substring(0,10) + "发布":''}}</div>
    </div>
    <div class="line-5"></div>
    <div class="configure">
      <h1>车辆档案</h1>
      <ul>
        <template v-if="resData.type === 2">
          <li>
            <span>上牌时间</span>
            <span>{{resData.firstLicenseDate|date}}</span>
          </li>
          <li>
            <span>里程数</span>
            <span>{{resData.mileage}}万公里</span>
          </li>
        </template>
        <template v-if="resData.type === 1">
          <li>
            <span>品牌</span>
            <span>{{resData.carBrandName}}</span>
          </li>
          <li>
            <span>车系</span>
            <span>{{resData.carSeriesName}}</span>
          </li>
        </template>
        <li>
          <span>车辆所在地</span>
          <span>{{resData.cityName}}</span>
        </li>
        <li v-if="resData.isGreen === 1">
          <span>进气方式</span>
          <span>{{GET_DICT(7,table.airIntakeMethodList)}}</span>
        </li>
        <li v-else>
          <span>排放标准</span>
          <span>{{GET_DICT(5,table.emissionsStandardr)}}</span>
        </li>
        <li>
          <span>变速箱</span>
          <span>{{GET_DICT(9,table.carGearboxType)}}</span>
        </li>
        <li>
          <span>排放量</span>
          <span>{{resData.outputVolumne}}</span>
        </li>
        <div class="clearfix"></div>
      </ul>
      <div>
        <router-link :to="'/Configure/'+resData.id">
          <span>查看更多配置</span>
          <img src="static/image/next@2x.png" alt />
        </router-link>
      </div>
    </div>
    <div class="line-5"></div>
    <van-panel title="车辆描述" :desc="resData.remark"></van-panel>
    <div class="line-5"></div>
    <div class="configure">
      <h1>车辆实拍</h1>
    </div>
    <div class="imgBox" :class="disabled?'imageBoxs':''">
      <div v-for="(item,key) in resData.imageList" v-bind:key="key" class="img">
        <img v-lazy="item" />
      </div>
      <div v-show="show" class="gradients"></div>
    </div>
    <div class="more" @click="onDisabled">
      <div>{{disabled ? '收起' : '全部展开'}}</div>
    </div>
    <div class="line-5"></div>
    <div class="carBox configure">
      <h1>相关推荐</h1>
    </div>
    <div class="new_car">
      <div class="new_car_list">
        <ul infinite-scroll-disabled="loading" infinite-scroll-distance="50">
          <li v-for="(item,key) in resList" v-bind:key="key" @click="linkCarInfo(item)">
            <div class="car_img float-left">
              <img :src="item.imgPath" />
            </div>
            <div class="car_titel float-right">
              <h1>{{item.carModelName}}</h1>
              <p>
                <em>{{item.firstLicenseDate?item.firstLicenseDate.substring(0, 7):''}}月上牌 / {{item.mileage}}万公里 / {{item.cityName}}</em>
              </p>
              <h2>
                <span>{{item.price}}万</span>
              </h2>
            </div>
            <div class="clearfix"></div>
          </li>
        </ul>
      </div>
    </div>
    <div class="line-5"></div>
    <div class="line-5"></div>
    <div class="line-59"></div>
    <div class="footer">
      <ul>
        <li class="header">
          <div>
            <img :src="resData.salespersonAvatar" alt />
          </div>
          <div>
            <h1>{{resData.salespersonName}}</h1>
            <span>{{resData.storeName}}</span>
          </div>
        </li>
        <li @click="callPhone">
          <span>电话咨询</span>
        </li>
      </ul>
    </div>
    <!-- <mt-popup v-model="popupVisible" position="bottom">
      <div class="ordered" v-if="!isLogin">
        <h1>咨询电话</h1>
        <span>我们会在第一时间与您联系</span>
        <hr />
        <ul>
          <li style="position: relative;">
            <span>手机号</span>
            <input placeholder="请输入手机号" v-model="body.identifier" type="text" />
            <button :disabled="count<60" @click="onGetCode">{{count>=60?'获取验证码':count}}</button>
          </li>
          <li>
            <span>验证码</span>
            <input placeholder="请输入验证码" v-model="body.code" type="text" />
          </li>
        </ul>
        <button @click="onLogin" :disabled="loading">{{loading?'预约中':'立即预约'}}</button>
      </div>


      <div class="ordered" v-if="isLogin">
        <h1>立即预约</h1>
        <span>我们会在第一时间与您联系</span>
        <ul>
          <li>
            <span>手机号</span>
            <input placeholder="请输入手机号" v-model="reserve.phone" type="text" />
          </li>
        </ul>
        <button @click="onReserve(null)" :disabled="loading">{{loading?'预约中':'立即预约'}}</button>
      </div>
    </mt-popup>-->
    <!-- <div class="success" v-show="reserveSuccessModal">
      <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.lianlianche.carcontact">
        <div class="success_box">
          <img class="close" @click="reserveSuccessModal=false" src="static/image/close@2x.png" alt />
          <h1>预约成功</h1>
          <span>查看预约</span>
          <div class="next">
            <span>免注册下载APP</span>
            <img src="static/image/next@2x.png" alt />
          </div>
        </div>
      </a>
    </div>-->
  </div>
</template>

<script>
/**
 * carModelName - 标题（车辆名称）
 * mileage - 公里数
 * newCarPrice - 新车价
 * price - 车价
 * type - 车辆类型  1（新车） 2（二手车）
 * carOilSystemLabel - 燃气形式/供油系统
 * carDriverTypeLabel - 驱动方式
 * carPlateCity - 车辆所在城市
 * emissionsStandardsLabel - 排放标准
 * carGearboxTypeLabel - 变速箱
 * outputVolumne - 排放量
 * firstLicenseDate - 初次上牌时间
 * carColor - 车系颜色
 * interiorColor - 内饰颜色
 * vinCode - VIN码
 * carBrandName - 车辆品牌
 * carSeriesName - 车系名称
 * carImages - 图片集合
 * airIntakeMethodLabel - 进气方式
 */
import {
  Swipe,
  SwipeItem,
  Header,
  Cell,
  DatetimePicker,
  Indicator,
  Toast
} from "mint-ui";
import {
  API_GET,
  API_POST,
  getLocation,
  getToken,
  API_GET_TOKEN,
  clearToken,
  GET_DICT,
  getUnionId,
  getInvitationCode
} from "@/apiConfig";
import Vue from "vue";
import ReportList from "./common/ReportListComponent"; // 播报组件
export default {
  name: "Details",
  data() {
    return {
      show: true,
      carSeriesId: "",
      cityId: this.$route.query.cityId,
      disabled: "",
      resData: {},
      resList: {},
      typeid:"",
      mapProvince: {}, // 匹配resData provinceId 的值
      mapCity: {}, // 匹配 resData 城市cityId 相关值
      carGearboxType: {
        0: `不限`,
        1: `MT(手动)`,
        2: `AT(自动)`,
        3: `AMT(机械式)`,
        4: `4CVT(无级)`,
        5: `DSG(双离合)`
      }, //  变速箱 0不限 1MT(手动) 2AT(自动) 3AMT(机械式) 4CVT(无级) 5DSG(双离合)
      reserve: {},
      loading: false,
      popupVisible: false, // 申请预约modal
      reserveSuccessModal: false, //预约成功modal
      GET_DICT: function() {},
      body: {
        identifier: "",
        code: "",
        type: "0"
      },
      count: 60,
      unionId: getUnionId(), // 微信浏览器端返回id
      isLogin: false, // 是否已经登录状态
      table: {
        emissionsStandardr: "", //排放标准
        carGearboxType: "", //变速箱
        airIntakeMethodList: "", //进气方式
      }
    };
  },
  mounted() {
    window.scroll(0, 0);
    this.GET_DICT = GET_DICT;
    this.fetchData();
    this.unionId = getUnionId();
    this.isLogin = getToken() ? true : false;
    /* eslint-disable */
  },
  methods: {
    goback: function() {
      window.history.go(-1);
    },

    callPhone: function() {
      window.location.href = "tel://" + this.resData.storeTelephone;
    },

    fetchData: function() {
      console.log(111111)
      console.log(this.$route.query.phone)
      let body = {
        carId: this.$route.params.id,
        phone: this.$route.query.phone
      };
      if (body.carId != null) {
        this.loading = true;
        API_GET("/lianlianche-car/car/share/detail", body).then(res => {
          this.loading = false;
          if (res.status == 0) {
            this.resData = res.data;
            this.table.emissionsStandardr =
              res.data.emissionsStandardList[0].classId;
            this.table.carGearboxType = res.data.carGearboxTypeList[0].classId;
            this.table.airIntakeMethodList = res.data.airIntakeMethodList[0].classId;
            this.carSeriesId = res.data.carSeriesId;
            console.log(res.data)
            this.getRecommend();
          } else {
            Toast({
              message: res.msg
            });
          }
        });
      }
    },

    getRecommend() {
      let body = {
        carSeriesId: this.carSeriesId,
        carId: this.$route.params.id,
        price: this.resData.price
      };
      this.loading = true;
      API_GET("/search/car/recommend", body).then(res => {
        console.log(res);
        this.loading = false;
        if (res.status == 0) {
          this.resList = res.data;
        }
      });
    },

    linkCarInfo: function(item) {
      console.log(this.phone);
      this.$router.push({
        name: "Details",
        params: { id: item.id }
      });
      this.fetchData();
      location.reload(true)  
    },

    // onShowReserve: function() {
    //   /**
    //    * 点击弹出立即预约弹出层
    //    */
    //   let token = getToken();
    //   if (this.isLogin) {
    //     /**
    //      * 如果登录了，
    //      * 弹出登录框
    //      */
    //     this.popupVisible = true;
    //     // this.$router.push("/login");
    //     // return;
    //   } else {
    //     /**
    //      * 如果没登录，
    //      * 弹出登录框
    //      */
    //     this.popupVisible = true;
    //   }
    //   // this.popupVisible = true;
    // },

    // onReserve: function(phone) {
    //   /**
    //    * 申请预约
    //    */

    //   let body = {
    //     carId: this.$route.params.id,
    //     cityZone: adcode
    //   };
    //   body.phone = phone
    //     ? phone
    //     : this.reserve.phone
    //     ? this.reserve.phone.trim()
    //     : "";
    //   // console.log(body.phone, "body.phonebody.phone");
    //   if (/^1[3456789]\d{9}$/.test(body.phone)) {
    //     this.loading = true;
    //     API_GET_TOKEN("/carBuyClue/reserve", body).then(res => {
    //       // Indicator.close();
    //       if (res.status == 0) {
    //         this.popupVisible = false;
    //         this.reserveSuccessModal = true;
    //       } else if (res.status == 600) {
    //         clearToken();
    //         // this.$router.push("/login");
    //         // Toast(`登录信息过期，请重新登录`);
    //       } else {
    //         Toast(res.msg);
    //       }
    //       this.loading = false;
    //     });
    //   } else {
    //     Toast({
    //       message: `请输入正确的手机号`
    //       // duration: -1,
    //     });
    //   }
    // },

    // onCollection: function() {
    //   /**
    //    * 收藏车辆
    //    */

    //   let body = {
    //     carId: this.$route.params.id
    //   };

    //   API_POST_TOKEN("/car/collection", body).then(res => {
    //     // Indicator.close();
    //     if (res.status == 0) {
    //       Toast(`车辆收藏成功`);
    //       // this.popupVisible = false;
    //       // this.reserveSuccessModal = true;
    //     } else if (res.status == 600) {
    //       clearToken();
    //       this.$router.push("/login");
    //       Toast(`登录信息过期，请重新登录`);
    //     } else {
    //       Toast(res.msg);
    //     }
    //     this.loading = false;
    //   });
    // },

    onLogin: function() {
      if (this.body.identifier && this.body.identifier.trim()) {
        this.loading = true;
        let _body = {}; // 提交登录的参数
        if (this.unionId) {
          /**
           * 如果是微信端打开
           */
          _body.type = 1;
          _body.bindPhone = this.body.identifier.trim();
          _body.identifier = this.unionId;
          _body.code = this.body.code;
          // this.body.type = 1;
          // this.body.bindPhone = this.body.identifier.trim();
          // this.body.identifier = this.unionId; // 这个登录名变成微信号
        } else {
          _body = Object.assign({}, this.body, { type: 0 });
          // this.type = 0;
        }
        API_POST(
          "https://user.lianlianche.com" + "/welcome/login",
          _body,
          true
        ).then(res => {
          this.loading = false;
          if (res.status == 0) {
            window.localStorage.setItem("token", res.data.token);
            window.localStorage.setItem("uid", res.data.uid);
            this.isLogin = true;

            if (this.unionId) {
              /**
               * 添加一步微信成功绑定 getInvitationCode
               */
              API_POST_TOKEN(
                "https://user.lianlianche.com/user/bindInvitationCode",
                {
                  invitationCode: getInvitationCode()
                },
                true
              );
            }
            // this.https.post(BindCode).then(res =>{
            //     window.localStorage.setItem("invitationCode", res.data.invitationCode);
            //     this.invitationCode = true
            // });

            /**
             * 登录成功后 走预约接口,
             *  手机号用刚刚登录的手机
             */
            let phone = this.unionId
              ? this.body.bindPhone
              : this.body.identifier.trim();
            this.onReserve(phone);

            // 登录时间设置为一个小时内有效
            // window.localStorage.setItem("invalidDate",Date.now()+1000*60*60);
            // Toast(`登录成功`);
            // window.history.back();
          } else {
            this.isLogin = false;
            Toast(res.msg);
          }
        });
      } else {
        Toast(`请填写正确的手机号码`);
        return;
      }
    },

    onGetCode: function() {
      /**
       * 发送验证码
       */
      if (this.body.identifier && this.body.identifier.trim()) {
        API_POST(
          "https://user.lianlianche.com" + "/welcome/sendMsg",
          { phone: this.body.identifier },
          true
        ).then(res => {
          if (res.status == 0) {
            let time = window.setInterval(() => {
              this.count--;
              if (this.count == 0) {
                time = null;
                this.count = 60;
              }
            }, 1000);
            Toast(`验证码已发送，请注意查收`);
          } else {
            Toast(res);
          }
        });
      } else {
        Toast(`请填写正确的手机号码`);
        return;
      }
    },

    linkStages: function(resData) {
      console.log(resData.carModelName)
      console.log(resData.price)
      this.$router.push({
        name: "byStages",
        params: { carModelName: resData.carModelName ,isGreen: resData.isGreen ,carBrandName:resData.carBrandName},
        query: { price: resData.price }
      });
    },

    onDisabled() {
      this.disabled = !this.disabled;
      this.show = !this.show;
    }

    // onMapCityData: function() {
    //   /**
    //    * 匹配 resData 市的值
    //    */
    //   let provinceId = this.resData.provinceId;
    //   let cityId = this.resData.cityId;

    //   if (provinceId && cityId) {
    //     API_POST("/city/listCityByProvinceId", { provinceId }).then(res => {
    //       if (res.status == 0) {
    //         res.data.forEach(v => {
    //           if (v.cityId == cityId) {
    //             console.log(v);
    //             this.mapCity = v;
    //           }
    //         });
    //       } else {
    //         Toast({
    //           message: res.msg
    //         });
    //       }
    //     });
    //   }
    // }
  },
  components: {
    ReportList
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
  color: #ffffff;
}
.mint-header {
  background-color: rgba(0, 0, 0, 0) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Details.vue